import gql from 'graphql-tag';

/**
 * Lấy nhiều sản phẩm theo danh sách id, field rút gọn đúng bằng homeProductSearch.ts
 * (chỉ những gì card trang chủ đọc) — khác query/product.ts là bản đầy đủ cho trang
 * chi tiết.
 *
 * Dùng để hydrate giá cho khối preload SSR: snapshot server gửi xuống chỉ có khung
 * (không có giá/isFavorite vì snapshot được cache dùng chung cho mọi user, còn hai
 * field đó là dữ liệu riêng theo buyer). Trước đây client hydrate bằng cách gọi LẠI
 * `productSearch` đúng page mà server đã dùng, nhưng phân trang là offset nên chỉ cần
 * catalog đổi giữa hai thời điểm (sản phẩm hết hàng bị `withInStock` lọc ra) là cùng
 * một page đã trỏ sang tập sản phẩm khác -> phần lớn id không khớp -> card treo
 * skeleton giá mãi mãi. Hỏi theo id thì không phụ thuộc page nên luôn khớp.
 *
 * MỘT query cho cả danh sách, KHÔNG phải N query `product(id:)`: đo trên QA thì
 * products(ids) ~0.3s, còn 10 x product(id) là ~2s khi đi batch link (batch trả về
 * theo operation chậm nhất) và timeout khi bắn 10 HTTP request song song.
 *
 * `ids` phải là `[ID!]` (không phải `[ID]`) mới khớp signature của BE.
 */
export default gql`
  query homeProductsByIds($ids: [ID!]) {
    products(ids: $ids) {
      id
      name
      imageUrl
      note
      supplierInternalCode
      uom
      uomLocal
      vat
      price
      originalPrice
      savingAmount
      inStock
      isFavorite
      tags
      allowAddToCart
      allowPurchase
      private
      tagImageVn
      tagImageEn
      baseUnit
      baseUom
      netUom
      netUnit
      netUomPrice
      baseUomPrice
      priceV2 {
        price
        originalPrice
        vat
        vatIncluded
      }
      category {
        name
        parent {
          name
        }
      }
      supplier {
        id
        name
      }
    }
  }
`;
